export default __webpack_public_path__ + "static/media/stsky.64b165db.JPG";